<template>
	<PopconfirmButton
		v-if="useConfirmation"
		:type="buttonType"
		:loading="isRunning"
		:disabled="disabled"
		:title="confirmationTitleText"
		:ok-text="confirmationOkText"
		:cancel-text="confirmationCancelText"
		:onConfirm="taskRun"
	>
		{{ buttonLabelText }}
	</PopconfirmButton>
	<Button
		v-else
		:type="buttonType"
		:loading="isRunning"
		:disabled="disabled"
		@click="taskRun"
	>
		{{ buttonLabelText }}
	</Button>
</template>

<script>
import { computed, toRef, onBeforeUnmount } from 'vue';
import { Button } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import { useTaskManager } from './useTaskManager.js'
import PopconfirmButton from './PopconfirmButton.vue';

export default {
	components: {
		Button,
		PopconfirmButton,
	},
	props: {
		buttonType: {
			type: String,
			default: 'primary',
		},
		taskLabel: {
			type: String,
		},
		buttonLabel: {
			type: String,
			default: 'settings.runScriptLabel',
		},
		disabled: {
			type: Boolean,
		},
		useConfirmation: {
			type: Boolean,
			default: false,
		},
		confirmationTitleLabel: {
			type: String,
			default: '',
		},
		confirmationOkLabel: {
			type: String,
			default: 'common.confirmButtonLabel',
		},
		confirmationCancelLabel: {
			type: String,
			default: 'common.cancelButtonLabel',
		},
		taskInputData: {
			type: Object,
			default: () => ({}),
		},
		waitLonger: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const taskLabelRef = toRef(props, 'taskLabel');
		const taskInputDataRef = toRef(props, 'taskInputData');
		const { isRunning, taskRun, unmount } = useTaskManager(taskLabelRef, taskInputDataRef, props.waitLonger);
		const buttonLabelText = computed(() => {
			if (isRunning.value) {
				return t('settings.runningScriptMessage');
			}
			return t(props.buttonLabel);
		});
		const confirmationTitleText = computed(() => {
			if (props.confirmationTitleLabel !== '') {
				return t(props.confirmationTitleLabel);
			}
			return t(props.buttonLabel);
		});
		const confirmationOkText = computed(() => t(props.confirmationOkLabel));
		const confirmationCancelText = computed(() => t(props.confirmationCancelLabel));
		onBeforeUnmount(() => unmount());
		return {
			isRunning,
			taskRun,
			unmount,
			buttonLabelText,
			confirmationTitleText,
			confirmationOkText,
			confirmationCancelText,
		};
	},
}
</script>
